module.exports = __webpack_public_path__ + "assets/img/portfolio-antras-2x.c805b887.jpg";